import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as UserLogo } from '../../assets/icons/user.svg?component';
import { ReactComponent as MenuLogo } from '../../assets/icons/menu.svg?component';
import { ReactComponent as Logo } from '../../assets/horario-certo-logo-horizontal.svg?component';
import { TopbarStyle } from './style';
import { Instagram, WhatsApp } from '@mui/icons-material';
import businessLogo from '../../assets/images/corporate-building.png';
import { isAdmin, isAvailableLogin, isProfessional, logout } from '../../util/auth';
import { ADMIN_MENU_ITEMS, professionalMenuItems } from '../sidebar';
import {Separator} from '../separator/style';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { isMobile, openInstagram, openWhatsApp } from '../../util/util';
import { isMobileApp } from '../../services/api';
import Cookies from "js-cookie";
import Dialog from '../dialog';
import styled from 'styled-components';
import { getCompanyProperties } from '../../services/endpoints/company';
import { fetchMaxProfessionals } from '../../services/endpoints/professional';
import { logoutCurrentCustomer, useCustomer } from '../../util/customerSession';

// Nome do cliente final logado, ao lado do botão da conta (agenda pública)
const CustomerName = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--ui-text);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DialogTitle = styled.h3`
  margin: 0 0 1rem 0;
  font-size: 1.15rem;
  color: var(--color-dark);
`;

const DialogText = styled.span`
  margin: 0 1rem 1.5rem 0;
  color: rgba(30, 44, 40, 0.8);
  line-height: 1.5;
`;

const DialogInput = styled.input`
  width: -webkit-fill-available;
  padding: 0.85rem 1rem;
  border: 1px solid rgba(30, 44, 40, 0.12);
  border-radius: 12px;
  margin-top: 1rem;
  font-size: 0.95rem;
  color: var(--color-dark);
  background: #f5f5f7;
`;

const DialogActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
`;

const DialogButton = styled.button`
  cursor: pointer;
  border: none;
  border-radius: 999px;
  padding: 0.85rem 1rem;
  font-weight: 600;
  font-size: 0.95rem;
  min-width: 120px;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

const CopyButton = styled(DialogButton)`
  background: var(--color-dark);
  color: #fff;
  align-items: center;
  justify-content: center;
`;

const WhatsAppButton = styled(DialogButton)`
  background: #25d366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function Topbar({imagem, whatsapp, instagram, name}) {
  const [isAuth, setIsAuth] = useState(false);
  const [open, setOpen] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Cliente final logado (área do cliente); só vale quando não há login de prestador
  const { customer } = useCustomer();
  const [mobile, setMobile] = useState();
  const [hasWhatsApp, setHasWhatsApp] = useState(false);
  const [scheduleMode, setScheduleMode] = useState("PADRAO");
  const [maxProfessionals, setMaxProfessionals] = useState(1);
  const companyUrl = Cookies.get("companyUrl");

  useEffect(() => {
    if(isAvailableLogin()) {
      setIsAuth(true);
    }
    setMobile(isMobile());

    try {
      const stored = Cookies.get("companyFeatures");
      if (stored) {
        const features = JSON.parse(stored);
        setHasWhatsApp(features.some((feature) => feature.name.toLowerCase().includes("whatsapp")));
      }
    } catch {}

    if (companyUrl && !isAdmin() && isAvailableLogin()) {
      getCompanyProperties(companyUrl)
        .then((response) => setScheduleMode(response.data?.scheduleMode || "PADRAO"))
        .catch(() => {});
      if (!isProfessional()) fetchMaxProfessionals(companyUrl).then(setMaxProfessionals);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleNavigate = (path) => {
    setOpen(false);
    navigate(path);
  }

  const handleLogout = async () => {
    setOpen(false);
    toast.success("Desconectado com sucesso!");
    setIsAuth(false);
    navigate(companyUrl ? '/'+companyUrl : '/login');
    await logout();
  }

  const shareUrl = `${window.location.origin}/${companyUrl}`;
  const safeImage = typeof imagem === 'string' ? imagem.trim() : '';
  const imageSrc = safeImage ? safeImage : businessLogo;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copiado para a área de transferência');
    } catch (error) {
      toast.error('Não foi possível copiar o link');
    }
  };

  const handleShareWhatsApp = () => {
    const message = `Olá! Venha conhecer os serviços de qualidade da ${name}!\n\n- Fácil de agendar\n- Rápido e seguro\n- Melhor atendimento\n\nClique aqui e agende seu horário agora: ${shareUrl}\n\nAté logo!`;
    const text = encodeURIComponent(message);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  const showEstablishment = (mobile && !isAuth) || (!mobile && !isAuth);

  const renderEstablishment = () => (
    <div className={mobile ? 'establishmentBoxMobile' : 'establishmentBox'}>
      <img
        src={imageSrc}
        onError={(event) => {
          event.currentTarget.onerror = null;
          event.currentTarget.src = businessLogo;
        }}
        alt="Logo do estabelecimento"
      />
      <div className="content">
        <span>{name}</span>
        <div className="social-media">
          <WhatsApp className="whatsapp" onClick={() => openWhatsApp(whatsapp)} />
          <Instagram className="instagram" onClick={() => openInstagram(instagram)} />
        </div>
      </div>
    </div>
  );

  // Login de cliente volta para a mesma página (ex.: a agenda do prestador) depois de entrar
  const customerLoginPath = `/area-do-cliente/entrar?redirect=${encodeURIComponent(location.pathname)}`;

  const handleCustomerLogout = async () => {
    setOpen(false);
    await logoutCurrentCustomer();
    toast.success('Você saiu da sua conta.');
  };

  const renderMenuCustomer = () => (
    <div className="menu" ref={menuRef}>
      {!mobile && <CustomerName>Olá, {customer.name.split(' ')[0]}</CustomerName>}
      <button
        className={mobile ? 'menu-button' : 'user-button'}
        onClick={() => setOpen(!open)}
        aria-label="Minha conta"
      >
        {mobile ? <MenuLogo /> : <UserLogo />}
      </button>
      {open && (
        <div className="user-dropdown">
          <div className="dropdown-item">
            <button onClick={() => handleNavigate('/area-do-cliente')}>Meus agendamentos</button>
          </div>
          <Separator $width="100%" $bordercolor="#ccc" $margin="0" $style="dotted" />
          <div className="dropdown-item">
            <button onClick={handleCustomerLogout}>Sair</button>
          </div>
        </div>
      )}
    </div>
  );

  const renderMenuNotAuth = () => (
    <>
      <div className="menu" ref={menuRef}>
        <button className="menu-button" onClick={() => setOpen(!open)}>
          <MenuLogo />
        </button>
        {open && (
          <div className="user-dropdown">
            <div className="dropdown-item">
              <button onClick={() => handleNavigate(customerLoginPath)}>Entrar</button>
            </div>
            <div className="dropdown-item">
              <button onClick={() => handleNavigate('/login')}>Sou empresa</button>
            </div>
          </div>
        )}
      </div>
    </>
  );

  const renderMenuAuth = () => (
    <div className="menu" ref={menuRef}>
      <button
        className={mobile ? 'menu-button' : 'user-button'}
        onClick={() => setOpen(!open)}
      >
        {mobile ? <MenuLogo /> : <UserLogo />}
      </button>
      {open && isAdmin() && (
        <div className="user-dropdown">
          {mobile && ADMIN_MENU_ITEMS.map((item) => (
            <div key={item.url} className="dropdown-item" onClick={() => handleNavigate(item.url)}>
              <button>{item.label}</button>
            </div>
          ))}
          {mobile && <Separator $width="100%" $bordercolor="#ccc" $margin="0" $style="dotted" />}
          <div className="dropdown-item">
            <button onClick={handleLogout}>Sair</button>
          </div>
        </div>
      )}
      {open && isProfessional() && (
        <div className="user-dropdown">
          {mobile && professionalMenuItems(scheduleMode).map((item) => (
            <div key={item.url} className="dropdown-item" onClick={() => handleNavigate(item.url)}>
              <button>{item.label}</button>
            </div>
          ))}
          {mobile && <Separator $width="100%" $bordercolor="#ccc" $margin="0" $style="dotted" />}
          <div className="dropdown-item">
            <button onClick={handleLogout}>Sair</button>
          </div>
        </div>
      )}
      {open && !isAdmin() && !isProfessional() && (
        <div className="user-dropdown">
          <div className="dropdown-item" onClick={() => handleNavigate('/dashboard')}>
            <button>Meu painel</button>
          </div>
          <div className="dropdown-item" onClick={() => handleNavigate('/'+companyUrl)}>
            <button>Minha agenda</button>
          </div>

          {!mobile && (
            <div className="dropdown-item" onClick={() => { setShareDialogOpen(true); setOpen(false); }}>
              <button>Link compartilhável</button>
            </div>
          )}

          {mobile ?
            <>
              {scheduleMode !== "SIMPLES" && (
                <div className="dropdown-item" onClick={() => handleNavigate('/agendamentos')}>
                  <button>Agendamentos</button>
                </div>
              )}
              {scheduleMode === "SIMPLES" && (
                <>
                  <div className="dropdown-item" onClick={() => handleNavigate('/configurar-horario-semanal')}>
                    <button>Configuração Horários</button>
                  </div>
                  <div className="dropdown-item" onClick={() => handleNavigate('/agenda-semanal')}>
                    <button>Agenda semanal</button>
                  </div>
                </>
              )}
              <div className="dropdown-item" onClick={() => handleNavigate('/servicos')}>
                <button>Serviços</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/analytics')}>
                <button>Análise</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/relatorios')}>
                <button>Relatórios</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/lista-de-espera')}>
                <button>Lista de Espera</button>
              </div>
              {maxProfessionals > 1 && (
                <div className="dropdown-item" onClick={() => handleNavigate('/profissionais')}>
                  <button>Profissionais</button>
                </div>
              )}
              <div className="dropdown-item" onClick={() => handleNavigate('/assinatura')}>
                <button>Assinatura</button>
              </div>
              {hasWhatsApp && (
                <div className="dropdown-item" onClick={() => handleNavigate('/notificacoes')}>
                  <button>Notificações</button>
                </div>
              )}
              {isMobileApp() && (
                <div className="dropdown-item" onClick={() => handleNavigate('/notificacoes-push')}>
                  <button>Notificações Push</button>
                </div>
              )}
              <div className="dropdown-item" onClick={() => handleNavigate('/alterar-senha')}>
                <button>Alterar senha</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/configuracoes')}>
                <button>Configurações</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/divulgacao')}>
                <button>Divulgação</button>
              </div>
              <div className="dropdown-item" onClick={() => handleNavigate('/ajuda')}>
                <button>Ajuda</button>
              </div>
              <div className="dropdown-item" onClick={() => { setShareDialogOpen(true); setOpen(false); }}>
                <button>Link compartilhável</button>
              </div>
            </>
          : <></>
          }
          <Separator $width="100%" $bordercolor="#ccc" $margin="0" $style="dotted" />
          <div className="dropdown-item">
            <button onClick={handleLogout}>Sair</button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <TopbarStyle>
        <>
          {showEstablishment && renderEstablishment()}

          {isAuth && <Logo className='logo' />}

          {!mobile && !isAuth && !customer && (
            <div className="menu">
              <button className="my-area" onClick={() => handleNavigate(customerLoginPath)}>
                Entrar
              </button>
            </div>
          )}

          {mobile && !isAuth && !customer && renderMenuNotAuth()}
          {!isAuth && customer && renderMenuCustomer()}
          {isAuth && renderMenuAuth()}

          <Dialog open={shareDialogOpen} onClose={() => setShareDialogOpen(false)} mobile={mobile}>
            <DialogTitle>Compartilhe sua agenda</DialogTitle>
            <DialogText>Copie o link da sua agenda ou compartilhe pelo WhatsApp com uma mensagem pronta.</DialogText>
            <DialogInput readOnly value={shareUrl} />
            <DialogActions>
              <CopyButton onClick={handleCopyLink}>Copiar link</CopyButton>
              <WhatsAppButton onClick={handleShareWhatsApp}>
                <WhatsApp style={{ marginRight: '0.5rem' }} />
                Compartilhar
              </WhatsAppButton>
            </DialogActions>
          </Dialog>
        </>
      <ToastContainer 
        position={mobile ? 'bottom-center' : 'top-right'} 
        style={mobile ? { margin: '0 5% 1rem 5%', width: '90%' } : undefined}
        autoClose={3000} 
      />
    </TopbarStyle>
  );
}
